import { IDynamicDiplayView } from '@components/widgets/dynamic-display';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';
import FormattingService from '@core/services/FormattingService';

import { MotorPolicy } from '../types';

export function buildMotorDetailsView(
  data: MotorPolicy,
  externalCode: string,
  currencySymbol: string
): IDynamicDiplayView {
  return {
    name: 'MotorDetails',
    sections: [
      {
        name: 'MotorDetails',
        title: 'Motor Details',
        properties: {
          nameOnLicenseEn: {
            multiline: false,
            value: data.nameOnLicenseEN,
            name: 'nameOnLicenseEn',
            title: 'Name on License (EN)'
          },
          nameOnLicenseAr: {
            multiline: false,
            value: data.nameOnLicenseAR,
            name: 'nameOnLicenseAr',
            title: 'Name on License (AR)'
          },
          vignetteCode: {
            multiline: false,
            value: data.vignetteCode,
            name: 'vignetteCode',
            title: 'Vignette Code',
            hidden: Number(externalCode) !== 50
          },
          vignette: {
            multiline: false,
            value: data.vignette?.toString(),
            name: 'vignette',
            title: 'Vignette',
            hidden: Number(externalCode) !== 50
          },
          plateCode: {
            multiline: false,
            value: data?.vehicle?.plateCode?.title,
            name: 'plateCode',
            title: 'Plate Code',
            sectionTitle: 'Vehicle Details'
          },
          plateNumber: {
            multiline: false,
            value: data?.vehicle?.plateNumber,
            name: 'plateNumber',
            title: 'Plate Number',
            sectionTitle: 'Vehicle Details'
          },
          usageType: {
            multiline: false,
            value: data?.vehicle?.usageType?.title,
            name: 'usageType',
            title: 'Usage',
            sectionTitle: 'Vehicle Details'
          },
          bodyType: {
            multiline: false,
            value: data?.vehicle?.bodyType?.title,
            name: 'bodyType',
            title: 'Body',
            sectionTitle: 'Vehicle Details'
          },
          engineType: {
            multiline: false,
            value: data?.vehicle?.engineType?.title,
            name: 'engineType',
            title: 'Engine Type',
            sectionTitle: 'Vehicle Details'
          },
          make: {
            multiline: false,
            value: data?.vehicle?.make?.title,
            name: 'make',
            title: 'Make',
            sectionTitle: 'Vehicle Details'
          },
          model: {
            multiline: false,
            value: data?.vehicle?.model?.title,
            name: 'model',
            title: 'Model',
            sectionTitle: 'Vehicle Details'
          },
          color: {
            multiline: false,
            value: data?.vehicle?.color?.title,
            name: 'color',
            title: 'Color',
            sectionTitle: 'Vehicle Details'
          },
          yearOfMake: {
            multiline: false,
            value: data?.vehicle?.yearOfMake?.toString(),
            name: 'yearOfMake',
            title: 'Year of Make',
            sectionTitle: 'Vehicle Details'
          },
          engine: {
            multiline: false,
            value: FormattingService.formatEnumToDisplay(data?.vehicle?.engine),
            name: 'engine',
            title: 'Engine',
            sectionTitle: 'Vehicle Details'
          },
          weight: {
            multiline: false,
            value: data?.vehicle?.weight?.toString(),
            name: 'weight',
            title: 'Weight (in Tons)',
            hidden: !['VAN', 'PICKUP', 'F_TANKER'].includes(
              data?.vehicle?.bodyType?.code
            ),
            sectionTitle: 'Vehicle Details'
          },
          engineSize: {
            multiline: false,
            value: data?.vehicle?.engineSize?.toString(),
            name: 'engineSize',
            title: 'Engine Size (in cc)',
            hidden: data?.vehicle?.bodyType?.code !== 'MOTORCYCLE',
            sectionTitle: 'Vehicle Details'
          },
          seatingCapacity: {
            multiline: false,
            value: data?.vehicle?.seatingCapacity?.toString(),
            name: 'seatingCapacity',
            title: 'Seating Capacity',
            sectionTitle: 'Vehicle Details'
          },
          chassis: {
            multiline: false,
            value: data?.vehicle?.chassis,
            name: 'chassis',
            title: 'Chassis',
            sectionTitle: 'Vehicle Details'
          },
          horsePower: {
            multiline: false,
            value: data?.vehicle?.horsePower?.toString(),
            name: 'horsePower',
            title: 'Horse Power',
            sectionTitle: 'Vehicle Details'
          },
          carValue: {
            multiline: false,
            value: data?.vehicle?.carValue?.toString(),
            name: 'carValue',
            title: 'Car Value',
            sectionTitle: 'Vehicle Details',
            hidden: Number(externalCode) !== 51,
            type: EnhancedDisplayType.RoundedCurrency,
            currencySymbol: currencySymbol
          },

          agencyRepairYears: {
            multiline: false,
            value: data.agencyRepairYears?.toString(),
            name: 'agencyRepairYears',
            title: 'Agency Repair Years',
            sectionTitle: 'Vehicle Details',
            hidden: Number(externalCode) !== 51
          },
          depreciationYears: {
            multiline: false,
            value: data.depreciationYears?.toString(),
            name: 'depreciationYears',
            title: 'Deprecation Years',
            sectionTitle: 'Vehicle Details',
            hidden: Number(externalCode) !== 51
          }
        }
      }
    ]
  };
}
